export default {
  'app.setting.pagestyle': 'გვერდის სტილის პარამეტრები',
  'app.setting.pagestyle.dark': 'მუქი სტილი',
  'app.setting.pagestyle.light': 'ნათელი სტილი',
  'app.setting.content-width': 'შიგთავსის სიგანე',
  'app.setting.content-width.fixed': 'ფიქსირებული',
  'app.setting.content-width.fluid': 'მორგებადი',
  'app.setting.themecolor': 'თემის ფერი',
  'app.setting.themecolor.dust': 'მტვრის წითელი',
  'app.setting.themecolor.volcano': 'ვულკანის ფერი',
  'app.setting.themecolor.sunset': 'მზის ჩასვლის ფორთოხლისფერი',
  'app.setting.themecolor.cyan': 'ცისფერი',
  'app.setting.themecolor.green': 'პოლარული მწვანე',
  'app.setting.themecolor.daybreak': 'განთიადის ლურჯი (ნაგულისხმები)',
  'app.setting.themecolor.geekblue': 'გიკების ლურჯი',
  'app.setting.themecolor.purple': 'ოქროს იისფერი',
  'app.setting.navigationmode': 'ნავიგაციის რეჟიმი',
  'app.setting.sidemenu': 'გვერდითი მენიუს განლაგება',
  'app.setting.topmenu': 'ზედა მენიუს განლაგება',
  'app.setting.fixedheader': 'ფიქსირებული ჰედერი',
  'app.setting.fixedsidebar': 'ფიქსირებული გვერდითი პანელი',
  'app.setting.fixedsidebar.hint': 'მუშაობს გვერდითი მენიუს განლაგებაში',
  'app.setting.hideheader': 'ჰედერის დამალვა გადახვევისას',
  'app.setting.hideheader.hint': 'მუშაობს, როცა ჰედერის დამალვა ჩართულია',
  'app.setting.othersettings': 'სხვა პარამეტრები',
  'app.setting.weakmode': 'ფერიანობის დაქვეითების რეჟიმი (Color Blind Friendly)',
  'app.setting.copy': 'პარამეტრების კოპირება',
  'app.setting.copyinfo':
    'კოპირება წარმატებულია, გთხოვთ ჩაანაცვლოთ defaultSettings ფაილში src/models/setting.js',
  'app.setting.production.hint':
    'პარამეტრების პანელი მხოლოდ განვითარების გარემოში ჩანს, გთხოვთ ხელით შეცვალოთ',
};
